// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js!../../../node_modules/css-loader/index.js??ref--2-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-3!../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./bootswatch.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("28a0444a", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js!../../../node_modules/css-loader/index.js??ref--2-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-3!../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./bootswatch.scss", function() {
     var newContent = require("!!../../../node_modules/mini-css-extract-plugin/dist/loader.js!../../../node_modules/css-loader/index.js??ref--2-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-3!../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./bootswatch.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}